export default __webpack_public_path__ + "static/media/photo--sm--39.0fce9fc4.jpg";